import React, {Component} from 'react';
import './Catalogue.css'
class FormElement extends Component{
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e){
        console.log(e)
        this.props.barcodeTag(e.value);
    }
    render(){
        return(
            <div className = "formElement">
                <form>
                    <label>Reader Tag
                        <input 
                            type="text" 
                            name = "reader" 
                            value = {this.props.readerTag}                             
                            style = {{marginLeft:42,backgroundColor:'lightgreen'}} 
                            readOnly/>
                    </label>
                    <br />

                    <label>BarCode Tag
                        <input 
                            type="text" 
                            style = {{marginLeft:30}} 
                            name="barcode"
                            value = {this.props.readerTag}                             

                            onChange = {(evt) => this.props.barcodeTag(evt.target.value)} 
                        />
                    </label>

                    <br />

                    <div className = " btngroup btn-toolbar">
                        <button style = {{marginRight : 10}} className = "btn" onClick = {this.props.refresh} type = "button">Refresh</button>
                        <button style = {{marginRight : 10}} className = "btn" onClick = {this.props.clearTable} type = "reset" >Clear</button>
                    </div> 
            </form>

            </div>
        )
    }
}

export default FormElement;


// WEBPACK FOOTER //
// ./src/Components/Magazine-Catalogue/FormElement.js